import { Box, Stack } from '@mui/joy';
import type { FunctionComponent } from 'react';

import AppbarLogo from './AppbarLogo/AppbarLogo';
import Navbar from './Navbar';
import Button from '../inputs/GButton/GButton';
import { redirectToExternalAuth } from '../../management/amplify-service';
import { signUserOut } from './AppbarProfile/AppBarProfile';
import AppSwitcher from './AppbarActions/AppSwitcher';

const NoAccessAppBar: FunctionComponent<{ showLogin: boolean }> = ({ showLogin = true }) => {
  return (
    <Navbar>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} width="100%">
        <AppbarLogo />
        <Box ml="auto">
          <AppSwitcher />
        </Box>
        <Button
          color="primary"
          width={showLogin ? 'normal' : 'small'}
          onClick={(): void => {
            if (showLogin) {
              redirectToExternalAuth();
              return;
            }

            signUserOut();
          }}
        >
          {showLogin ? 'Log in' : 'Log out'}
        </Button>
      </Stack>
    </Navbar>
  );
};

export default NoAccessAppBar;
